// =============================================================================
//  Copyright : 2018 semantics GmbH
//  Date      : $Date: 2025-09-21 19:16:35 +0200 (Sun, 21 Sep 2025) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 156393 $
//  Purpose   : parts for templating system
// =============================================================================
// ---Third-party imports
import React from 'react'

import now from 'performance-now'

// ---Framework imports
import log from 'uix/logging'
import {funcPart, loadLazy, Part} from 'uix/parts'

// ---Exports

const PartThemeBuilder = loadLazy(() => import(/* webpackChunkName: 'admin' */ './theming'))
export const ThemeBuilder = funcPart(
  {partStyle: {flex: 1, display: 'flex', flexDirection: 'column'}},
  props => <PartThemeBuilder {...props} />
)

export const InspectViews = loadLazy(() => import(/* webpackChunkName: 'admin' */ './inspectviews'))

export class FilterProgress extends Part {
  static storeMap = {
    progress: 'meta.progress',
  }

  _render() {
    let {visible, expectedDuration, duration, timestamp} = this.props.progress
    if (visible) {
      // phase I - update width from 0 to 100% in expectedDuration
      let widthPercent = (duration / expectedDuration) * 100
      let opacity = (now() - timestamp) / 5000

      // phase II - begin to remove it from the left in 2 * expectedDuration
      let left = 0
      if (widthPercent > 100) {
        left = (widthPercent - 100) / 2
        widthPercent = 100 - left
      }

      // phase III - loop each 3000 ms
      if (left > 100) {
        widthPercent = 6
        let x = ((now() - timestamp) % 3000) / 3000
        left = x * 100
        opacity = x
      }

      return (
        <div
          style={{
            width: `${widthPercent}%`,
            opacity,
            height: '0.3vh',
            left: `${left}%`,
            backgroundImage: 'linear-gradient(90deg, LawnGreen, ForestGreen)',
            position: 'absolute',
            zIndex: '1000',
          }}
        />
      )
    }
  }
}
